import { CommonModule } from "@angular/common";
import { NgModule, Pipe, PipeTransform } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { NgbDatepickerModule, NgbDropdownModule, NgbTimepickerModule } from "@ng-bootstrap/ng-bootstrap";
import { ModalModule } from "ngx-bootstrap/modal";
import { PerfectScrollbarConfigInterface, PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG } from "ngx-perfect-scrollbar";
import { NgxPermissionsModule } from "ngx-permissions";
import { Utils } from "src/app/@core/services/utils.service";
import { AlertModule } from "../alert/alert.module";
import { MenuAltComponent } from "../menu/menu-alt.component";
import { MenuIconComponent } from "../menu/menu-icon.component";
import { MenuComponent } from "../menu/menu.component";
import { MessageModule } from "./message/message.module";
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatNativeDateModule } from "@angular/material/core";
import { MatInputModule } from "@angular/material/input";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatMenuModule } from '@angular/material/menu';



const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@Pipe({
  name: 'safe'
})
export class SafePipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

}

@Pipe({
  name: 'numberformat'
})
export class NumberFormatPipe implements PipeTransform {

  constructor(private utils: Utils) { }
  transform(val) {
    return this.utils.formatNumbersToFixedWithCommas(val);
  }

}

@NgModule({
  imports: [
    MessageModule,
    AlertModule,
    CommonModule,
    PerfectScrollbarModule,
    RouterModule,
    FormsModule,
    ModalModule,
    ReactiveFormsModule,
    NgxPermissionsModule,
    NgbDropdownModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    MatIconModule,
    MatDatepickerModule,
    FormsModule,
    MatFormFieldModule,
    MatSelectModule,
	  MatNativeDateModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatMenuModule
  ],
  declarations: [
   SafePipe,NumberFormatPipe,MenuComponent,
   MenuAltComponent,
   MenuIconComponent,
  ],
  exports: [
    MessageModule,
    AlertModule,
    MenuComponent,
    MenuAltComponent,
    MenuIconComponent,
    NgxPermissionsModule,
    SafePipe,NumberFormatPipe,
    MatIconModule,
    MatDatepickerModule,
    FormsModule,
    MatFormFieldModule,
    MatSelectModule,
	  MatNativeDateModule,
    ReactiveFormsModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatMenuModule
    //PaymentComponent, SubscriptionModalComponent, CardModalComponent
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ]
})
export class SharedModule { }
